import { useMutation } from "@tanstack/react-query";
import type { StockLookup } from "@/lib/stock-lookup-view";

/** Greška pregleda stanja nosi `code` iz ugovora — UI po njemu bira poruku, ne po tekstu. */
export class StockLookupFailure extends Error {
  constructor(
    public code: string | null,
    public status: number,
    message: string,
  ) {
    super(message);
    this.name = "StockLookupFailure";
  }
}

/** Univerzalni scan: SKU se traži u svim zrcaljenim trgovinama, a otvorena trgovina ima
 *  prednost kad ga ima više. Radnik ne mora znati kojem shopu naljepnica pripada. */
export async function lookupStock(storeId: string | null, sku: string): Promise<StockLookup> {
  // URL builder, ne ručno spajanje: `+` i `/` u SKU-u moraju ostati dio vrijednosti.
  const params = new URLSearchParams({ sku, scope: "all" });
  if (storeId) params.set("storeId", storeId);
  const res = await fetch(`/api/products/stock-lookup?${params}`);
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    throw new StockLookupFailure(
      typeof body?.code === "string" ? body.code : null,
      res.status,
      body?.message || body?.error || res.statusText,
    );
  }
  return body as StockLookup;
}

/** `storeId` je prednost, ne filter — scan uvijek pretražuje sve zrcaljene trgovine. */
export function useStockLookup() {
  return useMutation({
    mutationFn: ({ sku, storeId }: { sku: string; storeId: string | null }) => lookupStock(storeId, sku),
  });
}
